module.exports = __webpack_public_path__ + "img/i108.1df8e801.png";